// DataContext.js
import React, {createContext, useState, useEffect, useContext, useRef} from 'react';
import {fetchPositions, getTabList, updateTickerSubscriptionWithKite} from '../services/apiService';


export const SharingContext = createContext();

export const SharingProvider = ({ children }) => {
    const [currentlyHeldPositions, setCurrentlyHeldPositions] = useState([]);  // State for new Instruments
    const [SharingContextLoading, setSharingContextLoading] = useState(true);  // Track loading state
    const [PosGridlayouts, setPosGridlayouts] = useState([]);
    const PosGridTabID=10;
    const [instrumentPriceMap, setInstrumentPriceMap] = useState(new Map());
    /*const [ticks, setTicks] = useState({}); // ✅ Store latest tick per instrumentToken*/
    const [pfQuotes, setPfQuotes] = useState([]); // ✅ Correct
    const updateTimeout = useRef(null); // Store timeout reference
    const [showFormattedNumbers, setShowFormattedNumbers] = useState(true);

    useEffect(() => {
        //console.log("pfQuotes updated:", pfQuotes);
    }, [pfQuotes]); // ✅ This ensures pfQuotes has updated before further usage

    useEffect(() => {
        fetchPositions().then(data => {
            if (data) {  // Check if data is not null or undefined
                setCurrentlyHeldPositions(data);
                setSharingContextLoading(false);  // Set loading to false once data is ready and valid
                console.log("SharingContext, SharingContextLoading set to false");

                const initialLayouts = data.map((position,index) => ({
                    i: `${PosGridTabID}-${position.instrumentToken}`,
                    x: 0,
                    y: index,  // Use sequenceNumber for y value
                    w: 1,
                    h: 1,
                }));
                setPosGridlayouts(initialLayouts);
            }
        })
    }, []);

    const addClosePrice = (instrumentToken, closePrice) => {
        setInstrumentPriceMap((prevMap) => {
            const updatedMap = new Map(prevMap);
            updatedMap.set(instrumentToken, closePrice);
            return updatedMap;
        });
    };
    const getClosePrice = async (instrumentToken) => {
        if (instrumentPriceMap.has(instrumentToken)) {
            return instrumentPriceMap.get(instrumentToken);
        }
    };

    return (
        <SharingContext.Provider value={{currentlyHeldPositions, setCurrentlyHeldPositions,SharingContextLoading,
            PosGridlayouts, setPosGridlayouts,PosGridTabID,addClosePrice,getClosePrice,pfQuotes,setPfQuotes,
            showFormattedNumbers,
            setShowFormattedNumbers
        }}>
            {children}
        </SharingContext.Provider>
    );
};

/*
// ✅ Custom hook to fetch latest tick for a specific instrumentToken
export const useTickForInstrument = (instrumentToken) => {
    const { ticks } = useSharingContext();
    return ticks[instrumentToken] ?? null; // ✅ Get the latest tick for any instrument
};
*/


export const useSharingContext = () => useContext(SharingContext);
